const eur0 = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const eur2 = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const int = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 });
const dec1 = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 });

const isNum = (v) => v !== null && v !== undefined && v !== '' && !Number.isNaN(Number(v));

/** € with no decimals (totals, values). */
export const fmtEur = (v, fallback = '—') => (isNum(v) ? eur0.format(Number(v)) : fallback);
/** € with cents (unit prices). Large values drop the cents. */
export const fmtPrice = (v, fallback = '—') => {
  if (!isNum(v)) return fallback;
  const n = Number(v);
  return Math.abs(n) >= 1000 ? eur0.format(n) : eur2.format(n);
};
/** Shop price without needless cents: 153 -> "€153", 149.5 -> "€149.50". */
export const fmtShopPrice = (v, fallback = '—') => {
  if (!isNum(v)) return fallback;
  const n = Number(v);
  return Number.isInteger(n) || Math.abs(n) >= 1000 ? eur0.format(n) : eur2.format(n);
};
/** Active discount vs RRP as a whole percentage, or null when there is none. */
export const discountPct = (price, rrp) => {
  if (!isNum(price) || !isNum(rrp) || Number(rrp) <= 0 || Number(price) >= Number(rrp)) return null;
  const pct = Math.round((1 - Number(price) / Number(rrp)) * 100);
  return pct >= 1 ? pct : null;
};
/** Value in k€ (e.g. "12.4k"). */
export const fmtK = (v, fallback = '—') => {
  if (!isNum(v)) return fallback;
  const n = Number(v) / 1000;
  if (n === 0) return '0';
  return `${Math.abs(n) >= 100 ? int.format(n) : dec1.format(n)}k`;
};
export const fmtInt = (v, fallback = '—') => (isNum(v) ? int.format(Number(v)) : fallback);
export const fmtDec = (v, fallback = '—') => (isNum(v) ? dec1.format(Number(v)) : fallback);
/** Two decimals ("1.05"). */
export const fmtDec2 = (v, fallback = '—') => (isNum(v) ? Number(v).toFixed(2) : fallback);
/** Small volumes keep meaning: 0.007 → "0.007", 1.234 → "1.23". */
export const fmtM3 = (v, fallback = '—') => {
  if (!isNum(v)) return fallback;
  const n = Number(v);
  if (n === 0) return '0';
  return n < 0.1 ? n.toPrecision(2).replace(/0+$/, '') : n.toFixed(2);
};
/** Ratio 0..1 → "24%". */
export const fmtPct = (v, fallback = '—') => (isNum(v) ? `${int.format(Number(v) * 100)}%` : fallback);
/** Signed percentage from percent points. */
export const fmtDeltaPct = (v, fallback = '—') => {
  if (!isNum(v)) return fallback;
  const r = Math.round(Number(v)); // API gives percent points (e.g. -14.3)
  return `${r > 0 ? '+' : ''}${r}%`;
};
export const fmtDate = (v, fallback = '—') => {
  if (!v) return fallback;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};
export const fmtDateTime = (v, fallback = '—') => {
  if (!v) return fallback;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
export const fmtAge = (days, fallback = '—') => {
  if (!isNum(days)) return fallback;
  return `${int.format(Number(days))} d`;
};

/** Shopify's placeholder variant name is noise. */
export const variantLabel = (v) => (v && v !== 'Default Title' ? v : '');
